module.exports = __webpack_public_path__ + "img/avatar2_old.be043cbb.png";